// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"57852":"ca766e9d030f506b","92888":"3e3d432990209c8e"}[chunkId] + ".css";
};